// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"126e27ae","55":"633c87a3","176":"46f2c375","181":"633c87a3","384":"9b1875dc","658":"126e27ae"}[chunkId] + ".chunk.css";
};